import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import Layout from '@/views/manager/index';
import mainChildren from './modules/main.js';
const ROUTES_VERSION = 3; //新版与老板路由切换

let routes = [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/register',
    name: 'register',
    hidden: true,
    component: () => import('@/views/login/register'),
    meta: {
      title: '管理后台-注册', // 可不用管 在beforeCreate中判断处理
      login: true, // main.js路由未登录调整需求 true代表不需要登录
      privilege: true, // 默认权限 true代表有权限进入
    }
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/login/login'),
    meta: {
      title: '管理后台-登录', // 可不用管 在beforeCreate中判断处理
      login: true,
      privilege: true, // 默认权限
    }
  },
  {
    path: '/news-content',
    name: 'news-content',
    hidden: true,
    component: () => import('@/views/supply/news-content.vue'),
    meta: {
      title: '新闻详情',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/screenindex',
    name: 'screenindex',
    hidden: true,
    component: () => import('@/views/screen/index'),
    meta: {
      title: '大屏管理系统',
      login: true,
      privilege: true, // 默认权限
    }
  },
  {
    path: '/readplat',
    name: 'readplat',
    hidden: true,
    component: () => import('@/views/platweb/readplat.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-performance',
    name: 'platweb-performance',
    hidden: true,
    component: () => import('@/views/platweb/performance.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-business',
    name: 'platweb-business',
    hidden: true,
    component: () => import('@/views/platweb/business.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-goodsSale',
    name: 'platweb-goodsSale',
    hidden: true,
    component: () => import('@/views/platweb/goods-sale.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-purchase',
    name: 'platweb-purchase',
    hidden: true,
    component: () => import('@/views/platweb/purchase.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-goodsStatic',
    name: 'platweb-goodsStatic',
    hidden: true,
    component: () => import('@/views/platweb/goods-statistics.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-order',
    name: 'platweb-order',
    hidden: true,
    component: () => import('@/views/platweb/order.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/platweb-payment',
    name: 'platweb-payment',
    hidden: true,
    component: () => import('@/views/platweb/payment.vue'),
    meta: {
      title: '',
      privilege: true, // 默认权限
    }
  },
  {
    path: '/locale',
    name: 'locale',
    component: () => import('@/views/locale.vue'),
    hidden: true,
    meta: {
      title: 'xlsx导入导出多语言',
      login: true,
      privilege: true, // 默认权限
    }
  }
]

// if (process.env.NODE_ENV === 'development') {
//   // 用于服务器资源配置上传
//   mainChildren.push({
//     path: '/updateOssData',
//     name: 'updateOssData',
//     component: () => import('@/views/setting/update-oss-data.vue'),
//     meta: {
//       title: '配置'
//     }
//   })
// }

if (ROUTES_VERSION == 3) {
  const routes_v3 = [{
      path: '/redirect',
      component: Layout,
      hidden: true,
      children: [{
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }]
    },
    {
      path: '/index',
      component: Layout,
      redirect: '/manager-welcome',
      meta: {
        title: '首页',
        privilege: true, // 默认权限
      },
      children: mainChildren
    },
    {
      path: '/',
      component: Layout,
      redirect: '/notfound',
      hidden: true,
      meta: {
        title: '管理后台',
      },
      children: [{
        path: '/notfound',
        name: '404',
        component: () => import('@/views/manager/notfound.vue'),
        meta: {
          title: '404',
          privilege: true, // 默认权限
        }
      }, {
        path: '/print-template',
        name: 'print-template',
        component: () => import('@/views/print-template'),
        hidden: true,
        meta: {
          title: '打印模板',
          privilege: true, // 默认权限
        }
      }]
    },
    {
      path: '*',
      redirect: '/notfound',
      hidden: true
    }
  ];
  routes = routes.concat(routes_v3);
} else {
  mainChildren.push({
    path: '/notfound',
    name: '404',
    component: () => import('@/views/manager/notfound.vue'),
    meta: {
      title: '404',
      privilege: true, // 默认权限
    }
  })
  const routes_v2 = [{
      path: '/index',
      name: 'index',
      component: () => import('@/views/manager/index'),
      meta: {
        title: '首页',
        privilege: true, // 默认权限
      },
      children: mainChildren
    },
    {
      path: '*',
      redirect: '/notfound',
      hidden: true
    }
  ]
  routes = routes.concat(routes_v2);
}

const router = new Router({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js